module.exports.USER_CURRENT_STATUS = {
  ANONYMOUS: 'ANONYMOUS',
  IN_ACTIVATION_PROCESS: 'IN_ACTIVATION_PROCESS',
  FREE_TRIAL: 'FREE_TRIAL',
  PRO_PLAN: 'PRO_PLAN',
  EXPIRED_FREE_TRIAL: 'EXPIRED_FREE_TRIAL',
};
